module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"comment":"Kommentar","order":"Bestellung"},"en":{"comment":"Comment","order":"Order"}}')
  delete Component.options._Ctor
}
